import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {SortKey} from 'search/SearchConstants';
import {Sortable} from 'search/SortForm';
import {getColumnHeaderFromSortKey} from 'search/SortUtil';

export function createSortable(sortKey: SortKey): Sortable {
  return {
    header: getColumnHeaderFromSortKey(sortKey),
    sortKey,
    sortDirection: null,
  };
}

export function getAvailableCustomSortables(selectedTypes: Array<string>): Array<Sortable> {
  if (selectedTypes.length === 1) {
    if (selectedTypes.includes(ModelTypeConstants.RECIPE_UNIT_OPERATION_TASK)) {
      return [createSortable(SortKey.SORT_RECIPE_METHOD_RECIPE_ORDER)];
    } else if (selectedTypes.includes(ModelTypeConstants.RECIPE_STEP_TASK)) {
      return [createSortable(SortKey.SORT_RECIPE_STEP_RECIPE_ORDER)];
    } else if (selectedTypes.includes(ModelTypeConstants.ASSAY_UNIT_OPERATION_TASK)) {
      return [createSortable(SortKey.SORT_ASSAY_METHOD_ASSAY_ORDER)];
    } else if (selectedTypes.includes(ModelTypeConstants.ASSAY_STEP_TASK)) {
      return [createSortable(SortKey.SORT_ASSAY_STEP_ASSAY_ORDER)];
    }
  }
  return [];
}

export function shouldShowSortDropdown(selectedClientOrigin: ProcessClientOrigin): boolean {
  const SORT_DROPDOWN_SUPPORTED_TYPES = [ProcessClientOrigin.RECIPES, ProcessClientOrigin.ASSAYS];
  return SORT_DROPDOWN_SUPPORTED_TYPES.includes(selectedClientOrigin);
}
